var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.9375 19.7489H15.8457V4.84071H0.9375V19.7489ZM14.6989 5.98749V18.6021H2.08428V5.98749H14.6989ZM20.4375 0.25V15.1593H16.9972V14.0114H19.2907V1.39678H6.67614V3.69033H5.52821V0.25H20.4375ZM4.37784 10.5782H12.4053V9.43141H4.37783V10.5782H4.37784ZM4.37784 15.1593H12.4053V14.0114H4.37783V15.1593H4.37784ZM4.37784 12.8682H10.1118V11.7214H4.37783V12.8682H4.37784Z",
    fill: "none",
    strokeWidth: 0.853125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildCourse);
export default __webpack_public_path__ + "static/media/Build Course.4dce352e953f5d3675c84eb93eab0cac.svg";
export { ForwardRef as ReactComponent };